import _ from "underscore";
import TemplateView from "../../TemplateView";
import LoadingControlMixin from "../LoadingControlMixin";
import classicBridge from '../../next/ClassicBridge'

export default class CFDropdownEditor extends TemplateView {
    constructor({
        $containerEl,
        selected,
        options,
        fieldName,
        onSelectedChanged,
        disabled,
        tooltipPlace,
        className,
    }) {
        super($containerEl);

        this.state = {
            disabled,
            selected,
            options,
        }

        this.params = {
            fieldName,
            onSelectedChanged,
            tooltipPlace,
            className,
        }

        this.onStatePropertyChanged('disabled', disabled => this.setDisabled(disabled))
        this.onStatePropertyChanged('selected', selected => this.setSelection(selected))
        this.onStatePropertyChanged('options', options => this.setOptions(options))
    }
    templateHtml() {
        return "<div class='dropdownSelectorButton atNextMount' />"
    }
    afterRender() {
        this.selector = classicBridge.integrateCFDropdownSelector(this.$el[0], {
            selected: this.state.selected,
            options: this.state.options,
            readonly: !!this.state.disabled,
            fieldName: this.params.fieldName,
            onSelectedChanged: this.params.onSelectedChanged,
            tooltipPlace: this.params.tooltipPlace,
            className: this.params.className,
        })
    }
    setSelection(selected) {
        this.selector.setProps({ selected })
    }
    setOptions(options) {
        this.selector.setProps({ options })
    }
    setDisabled(disabled) {
        this.selector.setProps({
            readonly: disabled
        })
    }
}

_.extend(CFDropdownEditor.prototype, LoadingControlMixin);


// WEBPACK FOOTER //
// ./web/js/controls/task/CFDropdownEditor.js